var qe = Object.defineProperty;
var Fe = (e, t, n) => t in e ? qe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var G = (e, t, n) => Fe(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as o, jsxs as N, Fragment as ee } from "react/jsx-runtime";
import { Text as J, Flex as K, Stack as H, Tooltip as A, IconButton as P, Divider as re, chakra as ne, Box as F, Menu as je, MenuButton as We, MenuList as Xe, MenuItem as W } from "@chakra-ui/react";
import { $isCodeNode as Pe, CodeNode as Se, getLanguageFriendlyName as Ke, CodeHighlightNode as Ye } from "@lexical/code";
import { $isLinkNode as X, $isAutoLinkNode as me, TOGGLE_LINK_COMMAND as Ce, $createLinkNode as Ve, LinkNode as Ge } from "@lexical/link";
import { ListNode as Je, ListItemNode as Qe } from "@lexical/list";
import { $convertFromMarkdownString as he, TRANSFORMERS as Q, $convertToMarkdownString as Ze } from "@lexical/markdown";
import { LexicalComposer as et } from "@lexical/react/LexicalComposer";
import { LexicalErrorBoundary as tt } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin as nt } from "@lexical/react/LexicalHistoryPlugin";
import { HorizontalRuleNode as ot } from "@lexical/react/LexicalHorizontalRuleNode";
import { ListPlugin as rt } from "@lexical/react/LexicalListPlugin";
import { OnChangePlugin as it } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin as lt } from "@lexical/react/LexicalRichTextPlugin";
import { TabIndentationPlugin as at } from "@lexical/react/LexicalTabIndentationPlugin";
import { TablePlugin as st } from "@lexical/react/LexicalTablePlugin";
import { $isHeadingNode as ct, $createHeadingNode as dt, QuoteNode as ut, HeadingNode as mt } from "@lexical/rich-text";
import { $createTableNode as gt, $createTableRowNode as pt, $createTableCellNode as ht, $isTableNode as ft, $getTableCellNodeFromLexicalNode as bt, TableCellNode as Me, $insertTableRow__EXPERIMENTAL as _t, $insertTableColumn__EXPERIMENTAL as Et, $deleteTableRow__EXPERIMENTAL as Ct, $deleteTableColumn__EXPERIMENTAL as yt, $isTableSelection as Tt, $isTableCellNode as ce, $getTableNodeFromLexicalNodeOrThrow as de, $getTableRowIndexFromTableCellNode as wt, $isTableRowNode as ye, $getTableColumnIndexFromTableCellNode as xt, getDOMCellFromTarget as Nt, TableNode as Rt, TableRowNode as kt } from "@lexical/table";
import { SELECTION_CHANGE_COMMAND as le, COMMAND_PRIORITY_CRITICAL as oe, CAN_UNDO_COMMAND as vt, CAN_REDO_COMMAND as Pt, UNDO_COMMAND as St, REDO_COMMAND as Mt, FORMAT_TEXT_COMMAND as ue, $getSelection as U, $isRangeSelection as Y, $isRootOrShadowRoot as Ot, $createParagraphNode as Lt, TextNode as ge, $createTextNode as fe, $getNearestNodeFromDOMNode as Z, $setSelection as Dt, DecoratorNode as Oe, $applyNodeReplacement as $t, CLICK_COMMAND as It, COMMAND_PRIORITY_LOW as Le, $isLineBreakNode as At, KEY_ESCAPE_COMMAND as Ut, COMMAND_PRIORITY_HIGH as De, $getRoot as zt } from "lexical";
import * as Bt from "react";
import { useState as y, useEffect as v, createContext as Ht, useContext as qt, useRef as $, useMemo as $e, Suspense as Ft, useCallback as D } from "react";
import { chakra as jt } from "@chakra-ui/system";
import { ContentEditable as Wt } from "@lexical/react/LexicalContentEditable";
import { useLexicalComposerContext as I } from "@lexical/react/LexicalComposerContext";
import { $setBlocksType as Te, $isAtNodeEnd as we } from "@lexical/selection";
import { mergeRegister as be, $findMatchingParent as q } from "@lexical/utils";
import { Icon as S, EmptyState as xe, VisualizationV2 as Xt, DataTable as Kt } from "@pufflig/prompt-studio-ui";
import { createPortal as te } from "react-dom";
import Yt from "lodash.debounce";
import Vt from "katex";
import { LinkPlugin as Gt } from "@lexical/react/LexicalLinkPlugin";
import { usePromptbookRuntime as Jt } from "@pufflig/promptbook-runtime";
import Qt from "papaparse";
import Ie from "@lexical/react/useLexicalEditable";
import { TreeView as Zt } from "@lexical/react/LexicalTreeView";
function Mo(e) {
  const { content: t = "" } = e;
  return /* @__PURE__ */ o(
    J,
    {
      textStyle: "body/M/regular",
      color: "text.placeholder",
      pointerEvents: "none",
      position: "absolute",
      top: "3.8rem",
      paddingLeft: "2.1rem",
      alignSelf: "center",
      width: "100%",
      maxWidth: "720px",
      children: t
    }
  );
}
const en = jt(Wt);
function tn({ onRef: e }) {
  return /* @__PURE__ */ o(K, { height: "100%", overflow: "auto", position: "relative", children: /* @__PURE__ */ o(K, { ref: e, width: "100%", justifyContent: "center", children: /* @__PURE__ */ o(
    en,
    {
      height: "fit-content",
      minH: "100%",
      width: "100%",
      maxWidth: "720px",
      paddingY: "spacing-sm",
      paddingX: "spacing-xxl",
      textStyle: "body/M/regular",
      position: "relative",
      outline: "none"
    }
  ) }) });
}
const nn = {
  bullet: "Bulleted List",
  check: "Check List",
  code: "Code Block",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",
  number: "Numbered List",
  paragraph: "Normal",
  quote: "Quote"
}, on = (e) => {
  const { isReadOnly: t } = e, [n] = I(), [r, i] = y("paragraph"), [a, g] = y(!1), [l, s] = y(!1), [d, m] = y(!1), [u, p] = y(!1), [b, E] = y(!1), h = (c) => {
    r !== c ? n.update(() => {
      const _ = U();
      Te(_, () => dt(c));
    }) : n.update(() => {
      const _ = U();
      Te(_, () => Lt());
    });
  }, T = () => {
    const c = U();
    if (Y(c)) {
      m(c.hasFormat("bold")), p(c.hasFormat("italic")), E(c.hasFormat("underline"));
      const _ = c.anchor.getNode();
      let M = _.getKey() === "root" ? _ : q(_, (C) => {
        const f = C.getParent();
        return f !== null && Ot(f);
      });
      M === null && (M = _.getTopLevelElementOrThrow());
      const O = ct(M) ? M.getTag() : M.getType();
      O in nn && i(O);
    }
  };
  return v(() => n.registerCommand(
    le,
    (c) => (T(), !1),
    oe
  ), [n, T]), v(() => be(
    n.registerCommand(
      vt,
      (c) => (g(c), !1),
      oe
    ),
    n.registerCommand(
      Pt,
      (c) => (s(c), !1),
      oe
    )
  ), [n]), e.isEmpty ? /* @__PURE__ */ o(
    H,
    {
      direction: "row",
      padding: "spacing-xs",
      paddingRight: "spacing-lg",
      alignItems: "center",
      borderBottom: "1px solid",
      borderColor: "border.secondary",
      maxH: "3rem",
      minH: "3rem"
    }
  ) : /* @__PURE__ */ N(
    H,
    {
      direction: "row",
      padding: "spacing-xs",
      paddingRight: "spacing-lg",
      alignItems: "center",
      borderBottom: "1px solid",
      borderColor: "border.secondary",
      maxH: "3rem",
      minH: "3rem",
      children: [
        /* @__PURE__ */ N(H, { direction: "row", gap: "0.5", children: [
          /* @__PURE__ */ o(A, { label: "Undo", "aria-label": "Undo", children: /* @__PURE__ */ o(
            P,
            {
              isDisabled: t || !a,
              bg: "transparent !important",
              onClick: () => {
                n.dispatchCommand(St, void 0);
              },
              variant: "ghost",
              "aria-label": "Undo",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "rotate-left", size: "sm" })
            }
          ) }),
          /* @__PURE__ */ o(A, { label: "Redo", "aria-label": "Redo", children: /* @__PURE__ */ o(
            P,
            {
              isDisabled: t || !l,
              bg: "transparent !important",
              onClick: () => {
                n.dispatchCommand(Mt, void 0);
              },
              variant: "ghost",
              "aria-label": "Redo",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "rotate-right", size: "sm" })
            }
          ) })
        ] }),
        /* @__PURE__ */ o(re, { orientation: "vertical", height: "1rem" }),
        /* @__PURE__ */ N(H, { direction: "row", gap: "0.5", children: [
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: d,
              onClick: () => {
                n.dispatchCommand(ue, "bold");
              },
              variant: "ghost",
              "aria-label": "Bold",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "text-bold", size: "sm" })
            }
          ),
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: u,
              onClick: () => {
                n.dispatchCommand(ue, "italic");
              },
              variant: "ghost",
              "aria-label": "Italic",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "text-italic", size: "sm" })
            }
          ),
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: b,
              onClick: () => {
                n.dispatchCommand(ue, "underline");
              },
              variant: "ghost",
              "aria-label": "Underline",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "text-underline", size: "sm" })
            }
          )
        ] }),
        /* @__PURE__ */ o(re, { orientation: "vertical", height: "1rem" }),
        /* @__PURE__ */ N(H, { direction: "row", gap: "0.5", children: [
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: r === "h1",
              variant: "ghost",
              "aria-label": "Bold",
              size: "sm",
              onClick: () => {
                h("h1");
              },
              icon: /* @__PURE__ */ o(J, { fontWeight: "thin", fontSize: ".9rem", children: "H1" })
            }
          ),
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: r === "h2",
              variant: "ghost",
              "aria-label": "Bold",
              size: "sm",
              onClick: () => {
                h("h2");
              },
              icon: /* @__PURE__ */ o(J, { fontWeight: "thin", fontSize: ".9rem", children: "H2" })
            }
          ),
          /* @__PURE__ */ o(
            P,
            {
              isDisabled: t,
              isActive: r === "h3",
              variant: "ghost",
              "aria-label": "Bold",
              size: "sm",
              onClick: () => {
                h("h3");
              },
              icon: /* @__PURE__ */ o(J, { fontWeight: "thin", fontSize: ".9rem", children: "H3" })
            }
          )
        ] })
      ]
    }
  );
}, Ae = Ht(void 0), rn = ({
  isStreaming: e,
  onEditResultClick: t,
  onExportResultClick: n,
  onTableTabClick: r,
  children: i
}) => {
  const a = { isStreaming: e, onEditResultClick: t, onExportResultClick: n, onTableTabClick: r };
  return /* @__PURE__ */ o(Ae.Provider, { value: a, children: i });
}, ln = () => {
  const e = qt(Ae);
  if (e === void 0)
    throw new Error("useEditorState must be used within an EditorStateProvider");
  return e;
}, an = {
  dependencies: [],
  export: (e, t) => ft(e) ? e.getChildren().map((r, i) => {
    const a = r.getChildren(), g = a.map((l) => l.getTextContent()).join(" | ");
    if (i === 0) {
      const l = a.map(() => "---").join(" | ");
      return `| ${g} |
| ${l} |`;
    }
    return `| ${g} |`;
  }).join(`
`) : null,
  regExp: /^\s*(\|.+\|)\s*$/,
  replace: (e, t, n, r) => {
    const i = e.getPreviousSibling(), a = (i == null ? void 0 : i.getType()) == "table";
    if (/^\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)*\|?$/gm.test(n[0])) {
      e.remove();
      return;
    }
    const l = a ? i : gt(), s = pt();
    n[0].split("|").slice(1, -1).map((m) => m.trim()).forEach((m, u) => {
      let p = ht(a ? 0 : 1);
      p.append(fe(m)), s.append(p), he(m, Q, p);
    }), l.append(s), a ? e.remove() : e.replace(l);
  },
  type: "element"
}, sn = {
  dependencies: [ge],
  export: (e, t) => {
    if (e instanceof ge) {
      let n = e.getTextContent();
      if (e.hasFormat("bold"))
        n = `**${n}**`;
      else if (e.hasFormat("italic"))
        n = `*${n}*`;
      else if (e.hasFormat("underline"))
        n = `<ins>${n}</ins>`;
      else
        return null;
      return n;
    }
    return null;
  },
  regExp: /<ins>(.*)<\/ins>/,
  importRegExp: /<ins>(.*)<\/ins>/,
  replace: (e, t) => {
    const n = fe(t[1]);
    n.toggleFormat("underline"), e.replace(n);
  },
  type: "text-match"
}, cn = {
  dependencies: [ge],
  export: (e, t) => null,
  regExp: /<u>(.*)<\/u>/,
  importRegExp: /<u>(.*)<\/u>/,
  replace: (e, t) => {
    const n = fe(t[1]);
    n.toggleFormat("underline"), e.replace(n);
  },
  type: "text-match"
}, dn = [an, sn, cn];
function un({ editor: e, getCodeDOMNode: t }) {
  const [n, r] = y(!1), i = () => {
    r(!1);
  };
  async function a() {
    const g = t();
    if (!g)
      return;
    let l = "";
    e.update(() => {
      const s = Z(g);
      Pe(s) && (l = s.getTextContent());
      const d = U();
      Dt(d);
    });
    try {
      await navigator.clipboard.writeText(l), r(!0), setTimeout(i, 1e3);
    } catch (s) {
      console.error("Failed to copy: ", s);
    }
  }
  return /* @__PURE__ */ o("button", { className: "menu-item", onClick: a, "aria-label": "copy", children: n ? /* @__PURE__ */ o(S, { name: "tick-circle" }) : /* @__PURE__ */ o(S, { name: "document-copy" }) });
}
function mn(e, t, n) {
  const r = $(null);
  return r.current = e, $e(
    () => Yt(
      (...i) => {
        r.current && r.current(...i);
      },
      t,
      { maxWait: n }
    ),
    [t, n]
  );
}
const gn = 8;
function pn({ anchorElem: e }) {
  const [t] = I(), [n, r] = y(""), [i, a] = y(!1), [g, l] = y(!1), [s, d] = y({
    right: "0",
    top: "0"
  }), m = $(/* @__PURE__ */ new Set()), u = $(null);
  function p() {
    return u.current;
  }
  const b = mn(
    (h) => {
      const { codeDOMNode: T, isOutside: c } = hn(h);
      if (c) {
        a(!1);
        return;
      }
      if (!T)
        return;
      u.current = T;
      let _ = null, M = "";
      if (t.update(() => {
        const O = Z(T);
        Pe(O) && (_ = O, M = _.getLanguage() || "");
      }), _) {
        const { y: O, right: C } = e.getBoundingClientRect(), { y: f, right: R } = T.getBoundingClientRect();
        r(M), a(!0), d({
          right: `${C - R + gn}px`,
          top: `${f - O}px`
        });
      }
    },
    50,
    1e3
  );
  v(() => {
    if (g)
      return document.addEventListener("mousemove", b), () => {
        a(!1), b.cancel(), document.removeEventListener("mousemove", b);
      };
  }, [g, b]), v(() => t.registerMutationListener(
    Se,
    (h) => {
      t.getEditorState().read(() => {
        for (const [T, c] of h)
          switch (c) {
            case "created":
              m.current.add(T);
              break;
            case "destroyed":
              m.current.delete(T);
              break;
          }
      }), l(m.current.size > 0);
    },
    { skipInitialization: !1 }
  ), [t]);
  const E = Ke(n);
  return /* @__PURE__ */ o(ee, { children: i ? /* @__PURE__ */ N("div", { className: "code-action-menu-container", style: { ...s }, children: [
    /* @__PURE__ */ o("div", { className: "code-highlight-language", children: E }),
    /* @__PURE__ */ o(un, { editor: t, getCodeDOMNode: p })
  ] }) : null });
}
function hn(e) {
  const t = e.target;
  if (t && t instanceof HTMLElement) {
    const n = t.closest("code.PlaygroundEditorTheme__code"), r = !(n || t.closest("div.code-action-menu-container"));
    return { codeDOMNode: n, isOutside: r };
  } else
    return { codeDOMNode: null, isOutside: !0 };
}
function fn({
  anchorElem: e = document.body
}) {
  return te(/* @__PURE__ */ o(pn, { anchorElem: e }), e);
}
const bn = Bt.lazy(() => import("./EquationComponent-C-yeS1BU.js"));
function Ne(e) {
  let t = e.getAttribute("data-lexical-equation");
  const n = e.getAttribute("data-lexical-inline") === "true";
  return t = atob(t || ""), t ? { node: ae(t, n) } : null;
}
class j extends Oe {
  constructor(n, r, i) {
    super(i);
    G(this, "__equation");
    G(this, "__inline");
    this.__equation = n, this.__inline = r ?? !1;
  }
  static getType() {
    return "equation";
  }
  static clone(n) {
    return new j(n.__equation, n.__inline, n.__key);
  }
  static importJSON(n) {
    return ae(n.equation, n.inline);
  }
  exportJSON() {
    return {
      equation: this.getEquation(),
      inline: this.__inline,
      type: "equation",
      version: 1
    };
  }
  createDOM(n) {
    const r = document.createElement(this.__inline ? "span" : "div");
    return r.className = "editor-equation", r;
  }
  exportDOM() {
    const n = document.createElement(this.__inline ? "span" : "div"), r = btoa(this.__equation);
    return n.setAttribute("data-lexical-equation", r), n.setAttribute("data-lexical-inline", `${this.__inline}`), Vt.render(this.__equation, n, {
      displayMode: !this.__inline,
      // true === block display //
      errorColor: "#cc0000",
      output: "html",
      strict: "warn",
      throwOnError: !1,
      trust: !1
    }), { element: n };
  }
  static importDOM() {
    return {
      div: (n) => n.hasAttribute("data-lexical-equation") ? {
        conversion: Ne,
        priority: 2
      } : null,
      span: (n) => n.hasAttribute("data-lexical-equation") ? {
        conversion: Ne,
        priority: 1
      } : null
    };
  }
  updateDOM(n) {
    return this.__inline !== n.__inline;
  }
  getTextContent() {
    return this.__equation;
  }
  getEquation() {
    return this.__equation;
  }
  setEquation(n) {
    const r = this.getWritable();
    r.__equation = n;
  }
  isInline() {
    return this.__inline;
  }
  decorate() {
    return /* @__PURE__ */ o(Ft, { fallback: null, children: /* @__PURE__ */ o(bn, { equation: this.__equation, inline: this.__inline }) });
  }
}
function ae(e = "", t = !1) {
  const n = new j(e, t);
  return $t(n);
}
function Ue(e) {
  return e instanceof j;
}
const _n = {
  dependencies: [j],
  export: (e) => Ue(e) && e.isInline() ? `\\( ${e.getEquation().trim()} \\)` : null,
  importRegExp: /\\\((.*?)\\\)/,
  regExp: /\\\((.*?)\\\)/,
  replace: (e, t) => {
    const n = ae(t[1].trim(), !0);
    e.replace(n);
  },
  type: "text-match"
}, En = {
  dependencies: [j],
  regExpStart: /\\\[/,
  regExpEnd: /\\]/,
  export: (e) => Ue(e) && !e.isInline() ? `\\[ ${e.getEquation().trim()} \\]` : null,
  replace: (e, t, n, r, i) => i ? (e.append(ae(i.join(" "), !1)), !0) : !1,
  type: "multiline-element"
};
function Cn() {
  const [e] = I();
  return v(() => {
  }, [e]), null;
}
function ie(e) {
  const t = e.anchor, n = e.focus, r = e.anchor.getNode(), i = e.focus.getNode();
  return r === i ? r : e.isBackward() ? we(n) ? r : i : we(t) ? r : i;
}
const yn = 10, Tn = 5;
function Re(e, t, n, r = yn, i = Tn) {
  const a = n.parentElement;
  if (e === null || !a) {
    t.style.opacity = "0", t.style.transform = "translate(-10000px, -10000px)";
    return;
  }
  const g = t.getBoundingClientRect(), l = n.getBoundingClientRect(), s = a.getBoundingClientRect();
  let d = e.top - r, m = e.left - i;
  d < s.top && (d += g.height + e.height + r * 2), m + g.width > s.right && (m = s.right - g.width - i), d -= l.top, m -= l.left, t.style.opacity = "1", t.style.transform = `translate(${m}px, ${d}px)`;
}
const wn = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);
function ke(e) {
  try {
    const t = new URL(e);
    if (!wn.has(t.protocol))
      return "about:blank";
  } catch {
    return e;
  }
  return e;
}
const xn = new RegExp(
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
);
function Nn(e) {
  return e === "https://" || xn.test(e);
}
function Rn({
  editor: e,
  isLink: t,
  setIsLink: n,
  anchorElem: r,
  isLinkEditMode: i,
  setIsLinkEditMode: a
}) {
  const g = $(null), l = $(null), [s, d] = y(""), [m, u] = y("https://"), [p, b] = y(null), E = D(() => {
    var f, R;
    const c = U();
    if (Y(c)) {
      const w = ie(c), x = q(w, X);
      x ? d(x.getURL()) : X(w) ? d(w.getURL()) : d(""), i && u(s);
    }
    const _ = g.current, M = window.getSelection(), O = document.activeElement;
    if (_ === null)
      return;
    const C = e.getRootElement();
    if (c !== null && M !== null && C !== null && C.contains(M.anchorNode) && e.isEditable()) {
      const w = (R = (f = M.focusNode) == null ? void 0 : f.parentElement) == null ? void 0 : R.getBoundingClientRect();
      w && (w.y += 40, Re(w, _, r)), b(c);
    } else (!O || O.className !== "link-input") && (C !== null && Re(null, _, r), b(null), a(!1), d(""));
    return !0;
  }, [r, e, a, i, s]);
  v(() => {
    const c = r.parentElement, _ = () => {
      e.getEditorState().read(() => {
        E();
      });
    };
    return window.addEventListener("resize", _), c && c.addEventListener("scroll", _), () => {
      window.removeEventListener("resize", _), c && c.removeEventListener("scroll", _);
    };
  }, [r.parentElement, e, E]), v(() => be(
    e.registerUpdateListener(({ editorState: c }) => {
      c.read(() => {
        E();
      });
    }),
    e.registerCommand(
      le,
      () => (E(), !0),
      Le
    ),
    e.registerCommand(
      Ut,
      () => t ? (n(!1), !0) : !1,
      De
    )
  ), [e, E, n, t]), v(() => {
    e.getEditorState().read(() => {
      E();
    });
  }, [e, E]), v(() => {
    i && l.current && l.current.focus();
  }, [i, t]);
  const h = (c) => {
    c.key === "Enter" ? (c.preventDefault(), T()) : c.key === "Escape" && (c.preventDefault(), a(!1));
  }, T = () => {
    p !== null && (s !== "" && (e.dispatchCommand(Ce, ke(m)), e.update(() => {
      const c = U();
      if (Y(c)) {
        const _ = ie(c).getParent();
        if (me(_)) {
          const M = Ve(_.getURL(), {
            rel: _.__rel,
            target: _.__target,
            title: _.__title
          });
          _.replace(M, !0);
        }
      }
    })), u("https://"), a(!1));
  };
  return /* @__PURE__ */ o("div", { ref: g, className: "link-editor", children: t ? i ? /* @__PURE__ */ N(ee, { children: [
    /* @__PURE__ */ o(
      "input",
      {
        ref: l,
        className: "link-input",
        value: m,
        onChange: (c) => {
          u(c.target.value);
        },
        onKeyDown: (c) => {
          h(c);
        }
      }
    ),
    /* @__PURE__ */ N("div", { children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: "link-cancel icon-close",
          role: "button",
          tabIndex: 0,
          onMouseDown: (c) => c.preventDefault(),
          onClick: () => {
            a(!1);
          }
        }
      ),
      /* @__PURE__ */ o(
        "div",
        {
          className: "link-confirm icon-check",
          role: "button",
          tabIndex: 0,
          onMouseDown: (c) => c.preventDefault(),
          onClick: T
        }
      )
    ] })
  ] }) : /* @__PURE__ */ N("div", { className: "link-view", children: [
    /* @__PURE__ */ o("a", { href: ke(s), target: "_blank", rel: "noopener noreferrer", children: s }),
    /* @__PURE__ */ o(
      "div",
      {
        className: "link-edit icon-edit-2",
        role: "button",
        tabIndex: 0,
        onMouseDown: (c) => c.preventDefault(),
        onClick: () => {
          u(s), a(!0);
        }
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: "link-trash icon-trash",
        role: "button",
        tabIndex: 0,
        onMouseDown: (c) => c.preventDefault(),
        onClick: () => {
          e.dispatchCommand(Ce, null);
        }
      }
    )
  ] }) : null });
}
function kn(e, t, n, r) {
  const [i, a] = y(e), [g, l] = y(!1);
  return v(() => {
    function s() {
      const d = U();
      if (Y(d)) {
        const m = ie(d), u = q(m, X), p = q(m, me);
        if (!(u || p)) {
          l(!1);
          return;
        }
        const b = d.getNodes().filter((E) => !At(E)).find((E) => {
          const h = q(E, X), T = q(E, me);
          return u && !u.is(h) || h && !h.is(u) || p && !p.is(T) || T && (!T.is(p) || T.getIsUnlinked());
        });
        l(!b);
      }
    }
    return be(
      e.registerUpdateListener(({ editorState: d }) => {
        d.read(() => {
          s();
        });
      }),
      e.registerCommand(
        le,
        (d, m) => (s(), a(m), !1),
        oe
      ),
      e.registerCommand(
        It,
        (d) => {
          const m = U();
          if (Y(m)) {
            const u = ie(m), p = q(u, X);
            if (X(p) && (d.metaKey || d.ctrlKey))
              return window.open(p.getURL(), "_blank"), !0;
          }
          return !1;
        },
        Le
      )
    );
  }, [e]), te(
    /* @__PURE__ */ o(
      Rn,
      {
        editor: i,
        isLink: g,
        anchorElem: t,
        setIsLink: l,
        isLinkEditMode: n,
        setIsLinkEditMode: r
      }
    ),
    t
  );
}
function vn({
  anchorElem: e = document.body
}) {
  const [t, n] = y(!1), [r] = I();
  return kn(r, e, t, n);
}
function Pn() {
  return /* @__PURE__ */ o(Gt, { validateUrl: Nn });
}
const pe = (e) => {
  const { value: t = "-" } = e;
  return /* @__PURE__ */ o(ne.span, { color: "foreground.accent.pink-dark", background: "background.accent-secondary.pink-light", children: t });
}, Sn = (e) => {
  const { result: t, onEditResult: n, onExportResult: r } = e, i = t.json, a = () => {
    const g = new Blob([JSON.stringify(i, null, 2)], {
      type: "application/json;charset=utf-8;"
    }), l = URL.createObjectURL(g), s = document.createElement("a");
    s.href = l, s.download = `${t.metadata.resultName || "result"}.json`, s.click(), URL.revokeObjectURL(l), r == null || r();
  };
  return typeof i == "string" ? /* @__PURE__ */ o(pe, { value: i }) : /* @__PURE__ */ N(F, { position: "relative", role: "group", children: [
    /* @__PURE__ */ N(
      H,
      {
        position: "absolute",
        right: "-2.5rem",
        top: 0,
        opacity: 0,
        transition: "opacity 0.2s",
        _groupHover: { opacity: 1 },
        children: [
          /* @__PURE__ */ o(A, { placement: "left", label: "Edit", "aria-label": "Edit", children: /* @__PURE__ */ o(
            P,
            {
              onClick: n,
              variant: "ghost",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "edit-2" }),
              "aria-label": "edit"
            }
          ) }),
          /* @__PURE__ */ o(A, { placement: "left", label: "Export", "aria-label": "Export", children: /* @__PURE__ */ o(
            P,
            {
              onClick: a,
              variant: "ghost",
              size: "sm",
              icon: /* @__PURE__ */ o(S, { name: "import-1" }),
              "aria-label": "export"
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ o(F, { border: "1px solid", borderColor: "border.secondary", borderRadius: "md", overflow: "hidden", children: /* @__PURE__ */ o(F, { maxHeight: "420px", overflow: "auto", children: /* @__PURE__ */ o(
      "code",
      {
        className: "PlaygroundEditorTheme__code PlaygroundEditorTheme__ltr",
        "cladata-language": "json",
        "data-highlight-language": "json",
        style: { marginTop: 0, marginBottom: 0 },
        children: JSON.stringify(i, null, 2)
      }
    ) }) })
  ] });
}, Mn = (e) => {
  var u;
  const { result: t, onEditResult: n, onExportResult: r, onOpenTableTab: i } = e, a = $(null), g = t.metadata.resultName, l = t.table || [], s = (u = t.visualizations) == null ? void 0 : u[0], d = l.length === 0, m = () => {
    if (s && a.current) {
      const p = a.current.querySelector("canvas");
      p && p.toBlob((b) => {
        if (!b) return;
        const E = URL.createObjectURL(b), h = document.createElement("a");
        h.href = E, h.download = `${g || "visualization"}.png`, h.click(), URL.revokeObjectURL(E), r == null || r();
      });
    } else {
      const p = Qt.unparse(l), b = new Blob([p], { type: "text/csv;charset=utf-8;" }), E = URL.createObjectURL(b), h = document.createElement("a");
      h.href = E, h.download = `${g || "table"}.csv`, h.click(), URL.revokeObjectURL(E), r == null || r();
    }
  };
  return /* @__PURE__ */ N(F, { position: "relative", role: "group", className: "onboarding__table_result_component", children: [
    /* @__PURE__ */ o(J, { textStyle: "label/M/regular", textAlign: "center", marginTop: "spacing-md", marginBottom: "spacing-sm", children: !s && g }),
    s && /* @__PURE__ */ N(ee, { children: [
      /* @__PURE__ */ N(
        H,
        {
          position: "absolute",
          right: "-2.5rem",
          top: s ? "0rem" : "2rem",
          opacity: 0,
          transition: "opacity 0.2s",
          _groupHover: { opacity: 1 },
          children: [
            /* @__PURE__ */ o(A, { placement: "left", label: "Table", "aria-label": "Table", children: /* @__PURE__ */ o(
              P,
              {
                onClick: i,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ o(S, { name: "table" }),
                "aria-label": "table"
              }
            ) }),
            /* @__PURE__ */ o(A, { placement: "left", label: "Edit", "aria-label": "Edit", children: /* @__PURE__ */ o(
              P,
              {
                onClick: n,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ o(S, { name: "edit-2" }),
                "aria-label": "edit"
              }
            ) }),
            /* @__PURE__ */ o(A, { placement: "left", label: "Export", "aria-label": "Export", children: /* @__PURE__ */ o(
              P,
              {
                onClick: m,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ o(S, { name: "import-1" }),
                "aria-label": "export"
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ o(K, { height: "420px", children: /* @__PURE__ */ o(
        K,
        {
          ref: a,
          flex: "1",
          border: "1px solid",
          _groupHover: { borderColor: "border.secondary" },
          borderColor: "transparent",
          borderRadius: "md",
          overflow: "hidden",
          children: d ? /* @__PURE__ */ o(xe, { title: "Empty Table", showBackground: !1 }) : /* @__PURE__ */ o(Xt, { data: { values: l }, spec: s })
        }
      ) })
    ] }),
    !s && /* @__PURE__ */ o(K, { maxHeight: "420px", justifyContent: "center", children: /* @__PURE__ */ N(F, { maxW: "100%", border: "1px solid", position: "relative", borderColor: "border.secondary", borderRadius: "md", children: [
      /* @__PURE__ */ N(
        H,
        {
          position: "absolute",
          right: "-2.5rem",
          top: 0,
          opacity: 0,
          transition: "opacity 0.2s",
          _groupHover: { opacity: 1 },
          children: [
            /* @__PURE__ */ o(A, { placement: "left", label: "Edit", "aria-label": "Edit", children: /* @__PURE__ */ o(
              P,
              {
                onClick: n,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ o(S, { name: "edit-2" }),
                "aria-label": "edit"
              }
            ) }),
            /* @__PURE__ */ o(A, { placement: "left", label: "Export", "aria-label": "Export", children: /* @__PURE__ */ o(
              P,
              {
                onClick: m,
                variant: "ghost",
                size: "sm",
                icon: /* @__PURE__ */ o(S, { name: "import-1" }),
                "aria-label": "export"
              }
            ) })
          ]
        }
      ),
      d ? /* @__PURE__ */ o(xe, { title: "Empty Table", showBackground: !1 }) : /* @__PURE__ */ o(Kt, { isReadOnly: !0, data: l, noBorder: !0 })
    ] }) })
  ] });
}, ve = (e, t) => {
  let i = (Array.isArray(e) && !t.startsWith("[") ? "[0]." + t : t).split(".").flatMap((a) => a.split(/\[|]/).filter(Boolean)).reduce((a, g) => a && a[g], e);
  return typeof i == "number" && !Number.isInteger(i) && (i = parseFloat(i.toFixed(2))), i;
}, On = (e) => (e == null ? void 0 : e.metadata.resultType) === "table", Ln = (e) => (e == null ? void 0 : e.metadata.resultType) === "json", Dn = (e) => {
  const [t, n] = y(null), [r, i] = y(!1), { runtime: a } = Jt(), { isStreaming: g, onEditResultClick: l, onExportResultClick: s, onTableTabClick: d } = ln();
  if (v(() => {
    if (!e.id || !a || g) return;
    (async () => {
      var E;
      try {
        const T = await (await ((E = a.storage) == null ? void 0 : E.loadRawFile(e.id))).text();
        n(JSON.parse(T)), i(!1);
      } catch {
        i(!0);
      }
    })();
  }, [e.id, a, g]), g)
    return /* @__PURE__ */ N(ne.span, { color: "foreground.secondary", bg: "background.secondary", borderRadius: "radius-xs", px: "spacing-xxs", children: [
      /* @__PURE__ */ o(S, { name: "credit-usage-0", size: "xxs", mr: "spacing-xxs" }),
      "loading"
    ] });
  if (!t && !r)
    return null;
  if (r)
    return /* @__PURE__ */ o(A, { label: `Missing data for ${e.id}`, "aria-label": `Missing data for ${e.id}`, children: /* @__PURE__ */ o(ne.span, { color: "foreground.feedback.alert", bg: "background.accent-secondary.red-light", children: r ? "Missing Result" : "-" }) });
  const m = () => {
    t && (l == null || l(t.metadata.resultId));
  }, u = () => {
    t && (s == null || s(t.metadata.resultId));
  }, p = () => {
    t && (d == null || d(t.metadata.resultId));
  };
  if (On(t)) {
    const b = e.path && ve(t.table, e.path);
    return e.path && typeof b != "object" ? /* @__PURE__ */ o(pe, { value: b }) : /* @__PURE__ */ o(
      Mn,
      {
        result: t,
        onEditResult: m,
        onExportResult: u,
        onOpenTableTab: p
      }
    );
  }
  if (Ln(t)) {
    const b = e.path && ve(t.json, e.path);
    return e.path && typeof b != "object" ? /* @__PURE__ */ o(pe, { value: b }) : /* @__PURE__ */ o(Sn, { result: t, onEditResult: m, onExportResult: u });
  }
  return /* @__PURE__ */ o(ne.span, { color: "foreground.feedback.alert", bg: "background.accent-secondary.red-light", children: "Invalid Result" });
};
class V extends Oe {
  constructor(n, r, i) {
    super(i);
    G(this, "__id");
    G(this, "__path");
    this.__id = n, this.__path = r;
  }
  static getType() {
    return "result";
  }
  static clone(n) {
    return new V(n.__id, n.__path, n.__key);
  }
  getId() {
    return this.__id;
  }
  getPath() {
    return this.__path;
  }
  createDOM(n, r) {
    return document.createElement("span");
  }
  decorate(n, r) {
    return /* @__PURE__ */ o(Dn, { id: this.__id, path: this.__path }, this.__key);
  }
  getTextContent() {
    return `{{RESULT:${this.__id}}}`;
  }
  exportJSON() {
    return {
      type: "result",
      version: 1,
      id: this.__id,
      path: this.__path
    };
  }
  static importJSON(n) {
    return ze(n.id, n.path);
  }
  updateDOM(n, r, i) {
    return !1;
  }
}
function ze(e, t) {
  return new V(e, t);
}
function $n(e) {
  return e instanceof V;
}
const In = {
  dependencies: [V],
  export: (e, t) => $n(e) ? e.getPath() ? `{{RESULT:${e.getId()}:${e.getPath()}}}` : `{{RESULT:${e.getId()}}}` : null,
  regExp: /\{\{RESULT:(\w+)(?::(.+?))?\}\}/,
  importRegExp: /\{\{RESULT:(\w+)(?::(.+?))?\}\}/,
  replace: (e, t) => {
    const n = ze(t[1], t[2]);
    e.replace(n);
  },
  type: "text-match"
};
function An() {
  const [e] = I();
  return v(() => {
  }, [e]), null;
}
function Un({ value: e }) {
  const [t] = I();
  return v(() => {
    e && t && t.update(
      () => {
        he(e, Q, void 0, !0);
      },
      { tag: "history-merge" }
    );
  }, [e, t]), null;
}
function zn({ tableCellNode: e }) {
  const [t] = I(), [n, r] = y(e), i = { columns: 1 };
  v(() => t.registerMutationListener(Me, (d) => {
    d.get(n.getKey()) === "updated" && t.getEditorState().read(() => {
      r(n.getLatest());
    });
  }), [t, n]);
  const a = D(
    (d) => {
      t.update(() => {
        _t(d);
      });
    },
    [t]
  ), g = D(
    (d) => {
      t.update(() => {
        for (let m = 0; m < i.columns; m++)
          Et(d);
      });
    },
    [t, i.columns]
  ), l = D(() => {
    t.update(() => {
      Ct();
    });
  }, [t]), s = D(() => {
    t.update(() => {
      yt();
    });
  }, [t]);
  return te(
    /* @__PURE__ */ N(Xe, { children: [
      /* @__PURE__ */ N(W, { onClick: () => a(!1), "data-test-id": "table-insert-row-above", children: [
        "Insert ",
        "row",
        " above"
      ] }),
      /* @__PURE__ */ N(W, { onClick: () => a(!0), "data-test-id": "table-insert-row-below", children: [
        "Insert ",
        "row",
        " below"
      ] }),
      /* @__PURE__ */ o(re, {}),
      /* @__PURE__ */ N(W, { onClick: () => g(!1), "data-test-id": "table-insert-column-before", children: [
        "Insert ",
        "column",
        " left"
      ] }),
      /* @__PURE__ */ N(W, { onClick: () => g(!0), "data-test-id": "table-insert-column-after", children: [
        "Insert ",
        "column",
        " right"
      ] }),
      /* @__PURE__ */ o(re, {}),
      /* @__PURE__ */ o(W, { onClick: () => s(), "data-test-id": "table-delete-columns", children: "Delete column" }),
      /* @__PURE__ */ o(W, { onClick: () => l(), "data-test-id": "table-delete-rows", children: "Delete row" })
    ] }),
    document.body
  );
}
function Bn({ anchorElem: e }) {
  const [t] = I(), n = $(null), [r, i] = y(null), a = D(() => {
    const l = n.current, s = U(), d = window.getSelection(), m = document.activeElement;
    if (s == null || l == null) {
      i(null);
      return;
    }
    const u = t.getRootElement();
    if (Y(s) && u !== null && d !== null && u.contains(d.anchorNode)) {
      const p = bt(s.anchor.getNode());
      if (p == null) {
        i(null);
        return;
      }
      if (t.getElementByKey(p.getKey()) == null) {
        i(null);
        return;
      }
      i(p);
    } else m || i(null);
  }, [t]);
  v(() => t.registerUpdateListener(() => {
    t.getEditorState().read(() => {
      a();
    });
  })), v(() => {
    const l = n.current;
    if (l != null && r != null) {
      const s = t.getElementByKey(r.getKey());
      if (s != null) {
        const d = s.getBoundingClientRect(), m = l.getBoundingClientRect(), u = e.getBoundingClientRect(), p = d.top - u.top + 7, b = d.right - m.width - 10 - u.left;
        l.style.opacity = "1", l.style.transform = `translate(${b}px, ${p}px)`;
      } else
        l.style.opacity = "0", l.style.transform = "translate(-10000px, -10000px)";
    }
  }, [n, r, t, e]);
  const g = $(r);
  return v(() => {
    g.current, g.current = r;
  }, [g, r]), /* @__PURE__ */ o(F, { position: "absolute", top: 0, left: 0, willChange: "transform", ref: n, children: r != null && /* @__PURE__ */ N(je, { children: [
    /* @__PURE__ */ o(
      We,
      {
        as: P,
        size: "xs",
        "aria-label": "Open table cell action menu",
        icon: /* @__PURE__ */ o(S, { name: "arrow-down-1", size: "sm" })
      }
    ),
    /* @__PURE__ */ o(zn, { tableCellNode: r })
  ] }) });
}
function Hn({ anchorElem: e = document.body }) {
  const t = Ie();
  return te(t ? /* @__PURE__ */ o(Bn, { anchorElem: e }) : null, e);
}
const qn = 33, Fn = 50;
function jn({ editor: e }) {
  const t = $(null), n = $(null), r = $(null), i = $(null), [a, g] = y(null), [l, s] = y(null), [d, m] = y(!1), [u, p] = y(null);
  v(() => e.registerCommand(
    le,
    () => {
      const C = U(), f = Tt(C);
      return d !== f && m(f), !1;
    },
    De
  ));
  const b = D(() => {
    s(null), t.current = null, p(null), i.current = null, r.current = null;
  }, []);
  v(() => {
    const C = (f) => {
      setTimeout(() => {
        const R = f.target;
        if (u) {
          g({
            x: f.clientX,
            y: f.clientY
          });
          return;
        }
        if (!(n.current && n.current.contains(R)) && t.current !== R) {
          t.current = R;
          const w = Nt(R);
          w && l !== w ? e.update(() => {
            const x = Z(w.elem);
            if (!x)
              throw new Error("TableCellResizer: Table cell node not found.");
            const k = de(x), L = e.getElementByKey(k.getKey());
            if (!L)
              throw new Error("TableCellResizer: Table element not found.");
            t.current = R, r.current = L.getBoundingClientRect(), s(w);
          }) : w == null && b();
        }
      }, 0);
    };
    return document.addEventListener("mousemove", C), () => {
      document.removeEventListener("mousemove", C);
    };
  }, [l, u, e, b]);
  const E = (C) => C === "bottom", h = D(
    (C) => {
      if (!l)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(() => {
        const f = Z(l.elem);
        if (!ce(f))
          throw new Error("TableCellResizer: Table cell node not found.");
        const R = de(f), w = wt(f), x = R.getChildren();
        if (w >= x.length || w < 0)
          throw new Error("Expected table cell to be inside of table row.");
        const k = x[w];
        if (!ye(k))
          throw new Error("Expected table row");
        k.setHeight(C);
      });
    },
    [l, e]
  ), T = D(
    (C) => {
      if (!l)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(() => {
        const f = Z(l.elem);
        if (!ce(f))
          throw new Error("TableCellResizer: Table cell node not found.");
        const R = de(f), w = xt(f), x = R.getChildren();
        for (let k = 0; k < x.length; k++) {
          const L = x[k];
          if (!ye(L))
            throw new Error("Expected table row");
          const z = L.getChildren(), se = z.map((B) => B.getColSpan()).reduce((B, Be) => {
            const He = B[B.length - 1] ?? 0;
            return B.push(He + Be), B;
          }, []).findIndex(
            (B) => B > w
          );
          if (se >= z.length || se < 0)
            throw new Error("Expected table cell to be inside of table row.");
          const Ee = z[se];
          if (!ce(Ee))
            throw new Error("Expected table cell");
          Ee.setWidth(C);
        }
      });
    },
    [l, e]
  ), c = D(
    (C) => {
      const f = (R) => {
        if (R.preventDefault(), R.stopPropagation(), !l)
          throw new Error("TableCellResizer: Expected active cell.");
        if (i.current) {
          const { x: w, y: x } = i.current;
          if (l === null)
            return;
          if (E(C)) {
            const k = l.elem.getBoundingClientRect().height, L = Math.abs(R.clientY - x), z = C === "bottom" && x > R.clientY;
            h(Math.max(z ? k - L : L + k, qn));
          } else {
            const k = getComputedStyle(l.elem);
            let L = l.elem.clientWidth;
            L -= parseFloat(k.paddingLeft) + parseFloat(k.paddingRight);
            const z = Math.abs(R.clientX - w), _e = C === "right" && w > R.clientX;
            T(Math.max(_e ? L - z : z + L, Fn));
          }
          b(), document.removeEventListener("mouseup", f);
        }
      };
      return f;
    },
    [l, b, T, h]
  ), _ = D(
    (C) => (f) => {
      if (f.preventDefault(), f.stopPropagation(), !l)
        throw new Error("TableCellResizer: Expected active cell.");
      i.current = {
        x: f.clientX,
        y: f.clientY
      }, g(i.current), p(C), document.addEventListener("mouseup", c(C));
    },
    [l, c]
  ), O = D(() => {
    if (l) {
      const { height: C, width: f, top: R, left: w } = l.elem.getBoundingClientRect(), x = {
        bottom: {
          backgroundColor: "none",
          cursor: "row-resize",
          height: "10px",
          left: `${window.pageXOffset + w}px`,
          top: `${window.pageYOffset + R + C}px`,
          width: `${f}px`
        },
        right: {
          backgroundColor: "none",
          cursor: "col-resize",
          height: `${C}px`,
          left: `${window.pageXOffset + w + f}px`,
          top: `${window.pageYOffset + R}px`,
          width: "10px"
        }
      }, k = r.current;
      return u && a && k && (E(u) ? (x[u].left = `${window.pageXOffset + k.left}px`, x[u].top = `${window.pageYOffset + a.y}px`, x[u].height = "3px", x[u].width = `${k.width}px`) : (x[u].top = `${window.pageYOffset + k.top}px`, x[u].left = `${window.pageXOffset + a.x}px`, x[u].width = "3px", x[u].height = `${k.height}px`), x[u].backgroundColor = "#adf"), x;
    }
    return {
      bottom: null,
      left: null,
      right: null,
      top: null
    };
  }, [l, u, a])();
  return /* @__PURE__ */ o("div", { ref: n, children: l != null && !d && /* @__PURE__ */ N(ee, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: "TableCellResizer__resizer TableCellResizer__ui",
        style: O.right || void 0,
        onMouseDown: _("right")
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: "TableCellResizer__resizer TableCellResizer__ui",
        style: O.bottom || void 0,
        onMouseDown: _("bottom")
      }
    )
  ] }) });
}
function Wn() {
  const [e] = I(), t = Ie();
  return $e(
    () => t ? te(/* @__PURE__ */ o(jn, { editor: e }), document.body) : null,
    [e, t]
  );
}
function Xn({ isEditable: e }) {
  const [t] = I();
  return v(() => {
    t.setEditable(e);
  }, [e, t]), null;
}
function Kn() {
  const [e] = I();
  return /* @__PURE__ */ o(F, { fontSize: "xs", color: "foreground.secondary", padding: "4", children: /* @__PURE__ */ o(
    Zt,
    {
      treeTypeButtonClassName: "debug-treetype-button",
      timeTravelButtonClassName: "debug-timetravel-button",
      timeTravelPanelButtonClassName: "debug-timetravel-button",
      timeTravelPanelClassName: "debug-timetravel-panel",
      timeTravelPanelSliderClassName: "debug-timetravel-slider",
      viewClassName: "tree-view-output",
      editor: e
    }
  ) });
}
const Yn = {
  code: "PlaygroundEditorTheme__code",
  codeHighlight: {
    atrule: "PlaygroundEditorTheme__tokenAttr",
    attr: "PlaygroundEditorTheme__tokenAttr",
    boolean: "PlaygroundEditorTheme__tokenProperty",
    builtin: "PlaygroundEditorTheme__tokenSelector",
    cdata: "PlaygroundEditorTheme__tokenComment",
    char: "PlaygroundEditorTheme__tokenSelector",
    class: "PlaygroundEditorTheme__tokenFunction",
    "class-name": "PlaygroundEditorTheme__tokenFunction",
    comment: "PlaygroundEditorTheme__tokenComment",
    constant: "PlaygroundEditorTheme__tokenProperty",
    deleted: "PlaygroundEditorTheme__tokenProperty",
    doctype: "PlaygroundEditorTheme__tokenComment",
    entity: "PlaygroundEditorTheme__tokenOperator",
    function: "PlaygroundEditorTheme__tokenFunction",
    important: "PlaygroundEditorTheme__tokenVariable",
    inserted: "PlaygroundEditorTheme__tokenSelector",
    keyword: "PlaygroundEditorTheme__tokenAttr",
    namespace: "PlaygroundEditorTheme__tokenVariable",
    number: "PlaygroundEditorTheme__tokenProperty",
    operator: "PlaygroundEditorTheme__tokenOperator",
    prolog: "PlaygroundEditorTheme__tokenComment",
    property: "PlaygroundEditorTheme__tokenProperty",
    punctuation: "PlaygroundEditorTheme__tokenPunctuation",
    regex: "PlaygroundEditorTheme__tokenVariable",
    selector: "PlaygroundEditorTheme__tokenSelector",
    string: "PlaygroundEditorTheme__tokenSelector",
    symbol: "PlaygroundEditorTheme__tokenProperty",
    tag: "PlaygroundEditorTheme__tokenProperty",
    url: "PlaygroundEditorTheme__tokenOperator",
    variable: "PlaygroundEditorTheme__tokenVariable"
  },
  embedBlock: {
    base: "PlaygroundEditorTheme__embedBlock",
    focus: "PlaygroundEditorTheme__embedBlockFocus"
  },
  list: {
    checklist: "PlaygroundEditorTheme__checklist",
    listitem: "PlaygroundEditorTheme__listItem",
    listitemChecked: "PlaygroundEditorTheme__listItemChecked",
    listitemUnchecked: "PlaygroundEditorTheme__listItemUnchecked",
    nested: {
      listitem: "PlaygroundEditorTheme__nestedListItem"
    },
    olDepth: [
      "PlaygroundEditorTheme__ol1",
      "PlaygroundEditorTheme__ol2",
      "PlaygroundEditorTheme__ol3",
      "PlaygroundEditorTheme__ol4",
      "PlaygroundEditorTheme__ol5"
    ],
    ol: "pb_document_editor_ol",
    ul: "pb_document_editor_ul"
  },
  heading: {
    h1: "pb_document_editor_h1",
    h2: "pb_document_editor_h2",
    h3: "pb_document_editor_h3"
  },
  paragraph: "pb_document_editor_p",
  text: {
    underline: "editor-textUnderline",
    code: "PlaygroundEditorTheme__textCode"
  },
  link: "PlaygroundEditorTheme__link",
  quote: "PlaygroundEditorTheme__quote",
  table: "PlaygroundEditorTheme__table",
  tableCell: "PlaygroundEditorTheme__tableCell",
  tableRow: "PlaygroundEditorTheme__tableRow",
  tableCellHeader: "PlaygroundEditorTheme__tableCellHeader"
};
function Oo(e) {
  const {
    debug: t = !1,
    defaultState: n = "",
    showToolbar: r = !0,
    isEditable: i = !0,
    placeholder: a,
    isStreaming: g = !1
  } = e, { onEditResultClick: l, onExportResultClick: s, onTableTabClick: d, onChange: m } = e, [u, p] = y(null);
  return /* @__PURE__ */ o(
    K,
    {
      className: "pb_document_editor",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      position: "relative",
      direction: "column",
      overflow: "hidden",
      children: /* @__PURE__ */ o(
        rn,
        {
          isStreaming: g,
          onEditResultClick: l,
          onExportResultClick: s,
          onTableTabClick: d,
          children: /* @__PURE__ */ N(et, { initialConfig: {
            namespace: "PB_DOCUMENT_EDITOR",
            nodes: [
              ot,
              ut,
              Ge,
              Me,
              Rt,
              kt,
              mt,
              Je,
              Qe,
              Se,
              Ye,
              j,
              V
            ],
            editorState: () => {
              Q.push(...dn, _n, En, In), he(n, Q, void 0, !0);
            },
            editable: i,
            onError: (h) => console.error(h),
            theme: Yn
          }, children: [
            r && /* @__PURE__ */ o(on, { isReadOnly: !i }),
            /* @__PURE__ */ o(Un, { value: n }),
            /* @__PURE__ */ o(Xn, { isEditable: i }),
            /* @__PURE__ */ o(nt, {}),
            /* @__PURE__ */ o(Pn, {}),
            /* @__PURE__ */ o(
              it,
              {
                ignoreSelectionChange: !0,
                ignoreHistoryMergeTagChange: !1,
                onChange: (h) => {
                  h.read(() => {
                    const T = zt();
                    m == null || m(Ze(Q, T, !0));
                  });
                }
              }
            ),
            /* @__PURE__ */ o(rt, {}),
            /* @__PURE__ */ o(at, {}),
            /* @__PURE__ */ o(Wn, {}),
            /* @__PURE__ */ o(st, {}),
            /* @__PURE__ */ o(
              lt,
              {
                contentEditable: /* @__PURE__ */ o(tn, { onRef: (h) => {
                  h !== null && p(h);
                } }),
                placeholder: a || null,
                ErrorBoundary: tt
              }
            ),
            /* @__PURE__ */ o(Cn, {}),
            /* @__PURE__ */ o(An, {}),
            u && /* @__PURE__ */ N(ee, { children: [
              /* @__PURE__ */ o(Hn, { anchorElem: u }),
              /* @__PURE__ */ o(vn, { anchorElem: u }),
              /* @__PURE__ */ o(fn, { anchorElem: u })
            ] }),
            t && /* @__PURE__ */ o(Kn, {})
          ] })
        }
      )
    }
  );
}
export {
  Oo as DocumentEditor,
  Mo as Placeholder
};
//# sourceMappingURL=index.js.map
